import React from "react";

const SmartSearch = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="27.569" height="19.861" viewBox="0 0 27.569 19.861">
			<path
				id="icons8-look"
				d="M14.9,7.992a.551.551,0,0,0-.345.111L.227,18.577a.551.551,0,0,0,.05.922l14.333,8.269a.551.551,0,1,0,.551-.954l-2.247-1.3a13.407,13.407,0,0,0,.4-15.062.552.552,0,0,0-.038-.053l1.931-1.41a.551.551,0,0,0-.306-1Zm7.824,5.581a1.1,1.1,0,0,0-.768,1.894l1.35,1.35H18.193a1.1,1.1,0,1,0,0,2.205h5.194l-1.426,1.426a1.1,1.1,0,1,0,1.559,1.559l4.049-4.05-4.05-4.05A1.1,1.1,0,0,0,22.729,13.573Zm-9.049.176a12.219,12.219,0,0,1,.486,1.942,2.538,2.538,0,0,0-.219,4.846l.046.014a12.207,12.207,0,0,1-.64,1.955,4.678,4.678,0,0,1,.326-8.758Z"
				transform="translate(-0.001 -7.992)"
				fill="#fff"
			/>
		</svg>
	);
};

export default SmartSearch;
